import PageHero from '../../components/PageHero';
import { Link } from 'react-router-dom';
import './StaticPage.css';

function AdvertisePage() {
  return (
    <div className="static-page content-page">
      <PageHero
        title="Advertise With Us"
        subtitle="Partner with India's wedding planning platform"
      />
      <div className="content-container">
        <p>
          WeddingzVenue offers targeted advertising opportunities for brands and businesses that want to
          reach couples during their wedding planning journey. From sponsored listings to banner campaigns,
          we help you connect with the right audience.
        </p>
        <h2>Why advertise on WeddingzVenue?</h2>
        <ul>
          <li>High-intent audience actively planning weddings</li>
          <li>Reach across multiple cities and regions</li>
          <li>Flexible formats: sponsored venues/vendors, banners, and more</li>
          <li>Transparent reporting and performance insights</li>
        </ul>
        <h2>Get in touch</h2>
        <p>
          For advertising enquiries and media kits, contact us at{' '}
          <a href="mailto:contact@weddingzvenue.in">contact@weddingzvenue.in</a> with the subject
          &quot;Advertising&quot; or use our <Link to="/contact">Contact</Link> page.
        </p>
      </div>
    </div>
  );
}

export default AdvertisePage;
